import {SlideStateVo} from '../../common/shared/api/nicolas/vo/enums/SlideStateVo.enum';
import {SlideState} from '../generated/types';

export function createSlideState(slide_state?: SlideStateVo): SlideState {
  if (!slide_state) {
    return SlideState.None;
  }
  return map[slide_state];
}

const map: {[key in SlideStateVo]: SlideState} = {
  [SlideStateVo.ST21]: SlideState.St21,
  [SlideStateVo.ST22]: SlideState.St22,
  [SlideStateVo.ST23]: SlideState.St23,
  [SlideStateVo.ST30]: SlideState.St30,
  [SlideStateVo.ST40]: SlideState.St40,
  [SlideStateVo.ST41]: SlideState.St41,
  [SlideStateVo.ST45]: SlideState.St45,
  [SlideStateVo.ST50]: SlideState.St50,
  [SlideStateVo.ST51]: SlideState.St51,
  [SlideStateVo.ST52]: SlideState.St52,
  [SlideStateVo.ST53]: SlideState.St53,
  [SlideStateVo.ST54]: SlideState.St54,
  [SlideStateVo.ST61]: SlideState.St61,
  [SlideStateVo.ST62]: SlideState.St62,
  [SlideStateVo.ST63]: SlideState.St63,
  [SlideStateVo.ST64]: SlideState.St64,
  [SlideStateVo.ST99]: SlideState.St99,
};
